import {WarningMessageAction} from '#/atoms/warning-message-action';
import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryParams} from 'use-query-params';

export const ActionMenuLandNotFound: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  const [{landToken}] = useQueryParams<SLQueryParamConfig>();

  const {
    actionMenu: {close},
  } = useQueryNavigationActions();

  return (
    <>
      <WarningMessageAction
        className='h-full space-y-2'
        message={t('components.warningMessageAction.noLocationCouldBeFound.message', {
          landTokenSymbol: landToken,
        })}
        buttonContent={t('components.warningMessageAction.noLocationCouldBeFound.cta')}
        action={close}
      />
    </>
  );
};
